const ConstructionStatus = {
    ACTIVE: "ACTIVE",
    ARCHIVED: "ARCHIVED"
}

export default ConstructionStatus;